export const DEFAULT_INVOICE_ITEMS_PER_PAGE = 30;
export const PRIMARY_FILTER_KEY = "STATUS";

export const MULTI_VALUE_STRICT_MATCH = false;
